import { rootProtectedPath, services } from "data/authData";
import GroupsIcon from "@mui/icons-material/Groups";
import { AccountCircleRounded, FacebookRounded, Google, HubRounded, Memory, UploadFile } from "@mui/icons-material";

export const audienceDrawerElements = {
	audience: {
		name: "Audience",
		key: "audience",
		display: true,
		icon: <GroupsIcon />,
		types: {
			facebook: {
				name: "Facebook",
				key: "facebook",
				display: true,
				icon: <FacebookRounded />,
			},
			// google: {
			// 	name: "Google",
			// 	key: "google",
			// 	display: true,
			// 	icon: <Google />,
			// },
			moengage: {
				name: "Moengage",
				key: "moengage",
				display: true,
				icon: <AccountCircleRounded />,
				// types: {
				// 	execute: {
				// 		name: "Execute",
				// 		key: "execute",
				// 		display: true,
				// 		icon: <Memory />,
				// 	},
				// 	upload_files: {
				// 		name: "Upload Files",
				// 		key: "upload_files",
				// 		display: true,
				// 		icon: <UploadFile />,
				// 	},
				// },
			},
			clevertap: {
				name: "CleverTap",
				key: "clevertap",
				display: true,
				icon: <HubRounded />,
			},
		},
	},
	// logs: {
	// 	name: "Logs",
	// 	key: "logs",
	// 	display: true,
	// 	icon: <GroupsIcon />,
	// 	types: {
	// 		facebook_logs: {
	// 			name: "Facebook Logs",
	// 			key: "facebook_logs",
	// 			display: true,
	// 			icon: <FacebookRounded />,
	// 		},
	// 		google_logs: {
	// 			name: "Google Logs",
	// 			key: "google_logs",
	// 			display: true,
	// 			icon: <Google />,
	// 		},
	// 		moengage_logs: {
	// 			name: "Moengage Logs",
	// 			key: "moengage_logs",
	// 			display: true,
	// 			icon: <AccountCircleRounded />,
	// 		},
	// 	},
	// },
};

export const selectOptKeyName = "select_options";
export const replenishmentParamName = "tab";

export const allOption = "ALL";

export const audienceFacebookPagePath = `/${rootProtectedPath}/${services.audience.path}/${audienceDrawerElements.audience.key}/${audienceDrawerElements.audience.types.facebook.key}`;
